import React from "react";
import Link from "components/elements/link";
import Svg from "components/elements/svg";

const HowItWorksButton = () => (
  <Link className="how-it-works-button" to="how-it-works">
    <span className="heading">How it works?</span>
    <span className="content">Learn more »</span>
    <Svg className="icon" src="how-it-works" />
  </Link>
);

export default HowItWorksButton;
